import React, { Ref } from 'react';
import MultiSelectField from './controls/fields/multiSelectField';
import {Option} from "react-multi-select-component";
import {WebCache} from "../services/WebCache";
import {UtilService} from '../services/UtilService';
import {OptionMapperHelper} from "../helpers/OptionMapperHelper";
import i18next from "i18next";

export interface MultiSelectRef extends FilterFiscalDocumentAndCommerce{
    clearFilters: () => void;
  }
interface IProps {
    changeFilter: (fiscalDocument: string[], merchantDocument: string[]) => void,
    columnClassName?:string,
    includeAllFiscalDocument:boolean
    includeAllMerchants?:boolean
    multiSelect?:boolean
    hideMerchants?:boolean
    includeWholesaler:boolean
    includeOnlyWholesaler?:boolean
    fiscalDocumentInitialValue?: string[],
    merchantNumberInitialValue?: string[]
}

interface IState {
    allFiscalDocuments:Option[],
    initialized:boolean,
    allMerchantNumbers:Option[],
    filters: {
        availableFiscalDocuments:Option[],
        availableMerchantNumbers:Option[],
        fiscalDocument: string[],
        merchantNumber: string[]
    }
}

class FilterFiscalDocumentAndCommerce extends React.Component<IProps, IState> implements MultiSelectRef{
    private optionMapper: OptionMapperHelper = new OptionMapperHelper(i18next.t);
    private divColumnSize: string = UtilService.isMobilePlatform() ? "col-md-6" : "col-sm-12 col-md-6 col-lg-4";

    constructor(props: IProps) {
        super(props);
        let allFiscalDocuments = WebCache.getAllMerchantDocuments(this.props.includeAllFiscalDocument, this.props.includeWholesaler, this.props.includeOnlyWholesaler);
        let allMerchantNumbers = OptionMapperHelper.getAllMerchantNumbersOptionsForMultipleFiscalDocuments(
            WebCache.getAllMerchantDocuments(false, this.props.includeWholesaler, this.props.includeOnlyWholesaler).map(doc => doc.label), true, this.props.includeWholesaler, this.props.includeOnlyWholesaler);
            allFiscalDocuments.forEach(option => {
                if (!option.key) {
                    option.key = option.value; //Definimos un valor para cuando key es undefined y no traiga inconvenientes en el render de los filtros
                }
        });

        allMerchantNumbers.forEach(option => {
            if (!option.key) {
                option.key = option.value; //Definimos un valor para cuando key es undefined y no traiga inconvenientes en el render de los filtros
            }
        });
        if(this.props.includeAllMerchants==false)
            allMerchantNumbers = allMerchantNumbers.filter(x => x.key !== "" && x.key !== undefined); // filtramos los merchant numbers que sean vacios o undefined


        this.state = {
            allFiscalDocuments,
            allMerchantNumbers,
            initialized:false,
            filters: {
                availableFiscalDocuments:allFiscalDocuments,
                availableMerchantNumbers:allMerchantNumbers,
                fiscalDocument: this.props.fiscalDocumentInitialValue??[allFiscalDocuments[0]?.key+""],
                merchantNumber: this.props.merchantNumberInitialValue??[allMerchantNumbers[0]?.key+""]
            }
        }
    }

    clearFilters = () => {
        this.setState({
            ...this.state,
            filters:{
                ...this.state.filters,
                fiscalDocument: [''],
                merchantNumber: ['']
            }
        });
    }
    componentDidMount() {
        if(!this.state.initialized){
            let filters =this.state.filters;
            this.props.changeFilter(filters.fiscalDocument, filters.merchantNumber);
        }

    }
    componentDidUpdate(prevProps: any, prevState: IState) {
        let changeState=false;
        let changeFilters=false
        let filters =this.state.filters;

        if(filters.fiscalDocument.length==0||(prevState.filters.fiscalDocument.filter(x=>x=="").length==0&&filters.fiscalDocument.filter(x=>x=="").length>0)){
            changeState=true;
            filters.fiscalDocument=[filters.availableFiscalDocuments[0].key+""];
        }else if(filters.fiscalDocument.length>1&&filters.fiscalDocument.filter(x=>x=="").length>0){
            changeFilters=true;
            filters.fiscalDocument=filters.fiscalDocument.filter(x=>x!="");
        }
        if(filters.merchantNumber.length==0||(prevState.filters.merchantNumber.filter(x=>x=="").length==0&&filters.merchantNumber.filter(x=>x=="").length>0)){
            changeState=true;
            if(this.props.includeAllMerchants==false&&filters.availableMerchantNumbers.length>0)
                filters.merchantNumber=[filters.availableMerchantNumbers[0].key+""];
            else
                filters.merchantNumber=[""];
        }else if(filters.merchantNumber.length>1&&filters.merchantNumber.filter(x=>x=="").length>0){
            changeState=true;
            filters.merchantNumber=filters.merchantNumber.filter(x=>x!="");
        }
        if (!changeState) {
            let merchantNumbers = this.props.hideMerchants?[]:OptionMapperHelper.getAllMerchantNumbersOptionsForMultipleFiscalDocuments(this.state.filters.fiscalDocument,
                true,this.props.includeWholesaler);
            if(this.props.includeAllMerchants==false)
                merchantNumbers=merchantNumbers.filter(x=>x.key!="");
            var filteredMerchants = this.state.filters.merchantNumber.filter(x=>x==""||merchantNumbers.map(x=>x.key).includes(x));
            if(this.state.filters.availableMerchantNumbers.length!=merchantNumbers.length||this.state.filters.availableMerchantNumbers.filter(x=>merchantNumbers.filter(y=>x.key==y.key).length==0).length>0){
                changeState=true;
                filters.merchantNumber=filteredMerchants;
                filters.availableMerchantNumbers=merchantNumbers;
            }else
                changeState=changeFilters||prevState.filters.fiscalDocument.length!=filters.fiscalDocument.length||
                    prevState.filters.merchantNumber.length!=filters.merchantNumber.length;

        }
        if(!changeState&&
            !this.props.multiSelect&&
            filters.merchantNumber!=null&&
               prevState.filters.merchantNumber!=null&&
               filters.merchantNumber.length>0!=null&&
               prevState.filters.merchantNumber.length>0!=null&&
               filters.merchantNumber[0]!=prevState.filters.merchantNumber[0])
            changeState=true;

        if(changeState||!this.state.initialized){
            this.setState({filters,initialized:true});
            this.props.changeFilter(filters.fiscalDocument, filters.merchantNumber);
        }
    }

    render() {

        const currentUser = WebCache.getCurrentUser()?.countryId;
        let fiscalDocumentLabel;

        if (currentUser !== undefined && currentUser === 2) {
            fiscalDocumentLabel = i18next.t('merchantDocument');
        } else {
            fiscalDocumentLabel = i18next.t('merchantDocumentArg');
        }
        return (
        <>
            <div className={this.props.columnClassName==undefined ? this.divColumnSize : this.props.columnClassName}>
                <MultiSelectField
                    multiSelect={this.props.multiSelect==null||this.props.multiSelect}
                    attr="fiscalDocument"
                    label={fiscalDocumentLabel}
                    options={this.optionMapper.translateOptionValues(this.state.filters.availableFiscalDocuments)}
                    selectedOptions={this.state.filters.fiscalDocument}
                    setSelectedOptions={(selected:any) => this.setState({...this.state, filters:{...this.state.filters,fiscalDocument:selected}})}
                />
            </div>
            <div className={this.props.columnClassName==undefined? this.divColumnSize :this.props.columnClassName} hidden={this.props.hideMerchants}>
                <MultiSelectField
                    multiSelect={this.props.multiSelect==null||this.props.multiSelect}
                    attr="merchantNumber"
                    label={i18next.t(`merchantNumber`)}
                    options={this.optionMapper.translateOptionValues(this.state.filters.availableMerchantNumbers)}
                    selectedOptions={this.state.filters.merchantNumber}
                    setSelectedOptions={(selected:any) => this.setState({...this.state, filters:{...this.state.filters,merchantNumber:selected}})}
                />
            </div>
        </>
    );
    };
}
export default React.forwardRef<MultiSelectRef, IProps>((props, ref) => (
    <FilterFiscalDocumentAndCommerce {...props} ref={ref as React.Ref<MultiSelectRef>} />
));